import { Outlet, useParams } from 'react-router-dom'

import { Spinner } from '@factorialco/deprecated-design-system'
import {
  ApprovalGroupRootPageDocument,
  ApprovalGroupRootPageQuery,
  ApprovalsValueObjectsApprovalCategoryEnum,
} from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useLazyQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/approvals/lib/CollectionsBootstrap'

const TIMEOFF = 'timeoff'
const EXPENSES = 'expenses'
const Time_Tracking = 'time_tracking'
const ATS = 'ats'
const CONTRACTS = 'contracts'
const SOFTWARE = 'software'
const PURCHASES = 'purchases'
const TRAININGS = 'trainings'

const Container = () => {
  const params = useParams<{ category: ApprovalsValueObjectsApprovalCategoryEnum; id: string }>()

  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { id, category } = params

  const authorized = (data: ApprovalGroupRootPageQuery) => {
    switch (category) {
      case TIMEOFF:
        return data.timeoff._policies.companyManageTimeoff.can
      case EXPENSES:
        return data.expenses._policies.settingsSeeExpensesSettings.can
      case Time_Tracking:
        return data.attendance._policies.accessEditSettings.can
      case ATS:
        return data.ats._policies.manageAtsSettings.can
      case CONTRACTS:
        return data.contracts._policies.contractEditContractsSettings.can
      case SOFTWARE:
        return data.itManagement._policies.settingsSeeSoftwareSettings.can
      case PURCHASES:
        return data.procurement._policies.settingsManage.can
      case TRAININGS:
        return true
      default:
        throw new Error(`Unrecognized category ${category}`)
    }
  }

  const [fetchApprovalGroupPage, { data, loading }] = useLazyQuery(ApprovalGroupRootPageDocument)

  useEffect(() => {
    if (!category || !id) return
    fetchApprovalGroupPage({
      variables: {
        companyId,
        id: Number(id),
        category: category,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, companyId, id])

  const group = data?.approvals.approvalGroup

  if (loading || !data) {
    return <Spinner />
  }

  const can = authorized(data)

  return (
    <AuthorizeUser authorizeFn={() => can}>
      <Outlet context={{ group }} />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
